@if (operator == 0 || operator == 1) {
  <mat-form-field>
    <mat-select placeholder="{{ 'generic.selectList' | translate }}..." multiple (selectionChange)="addItemfromDropdown()" [(value)]="value">
      @for (item of type === "goals" ? suggestions : (filteredOptions | async); track item) {
        <mat-option [matTooltip]="item.tooltip" [style.borderBottom]="item.displayName === 'Danish' ? '1px solid #d8d8d8' : ''" [value]="item.id">
          @if (type === "country") {
            <span>{{ "countries." + item.id | lowercase | translate }}</span>
          }
          @if (type !== "country") {
            <span [innerHtml]="item.displayName"></span>
          }
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
} @else {
  <mat-form-field>
    <input
      type="text"
      placeholder="{{ 'generic.typeSomething' | translate }}..."
      matInput
      [formControl]="autocompleteControl"
      [matAutocomplete]="auto"
      (change)="addItemfromTextField()" />
    <mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption (optionSelected)="addItemFromAutoComplete($event)">
      @for (item of type === "goals" ? suggestions : (filteredOptions | async); track item) {
        <mat-option [matTooltip]="item.tooltip" [value]="item.id">
          <span [innerHtml]="item.displayName"></span>
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
}
